import { View, Text, Image, ScrollView, TouchableOpacity } from "react-native";
import React, { useEffect, useState } from "react";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import {
  useDeviceSize,
  CreateResponsiveStyle,
  DEVICE_SIZES,
} from "rn-responsive-styles";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppImages } from "../../../utility/AppImages";
import { getLoginData } from "../../../utility/AppStoreData";
import * as Linking from "expo-linking";
import { fetchPaymentCreateSession } from "../../../services/profileAPI";
import VerificationModal from "./VerificationModal";
import PurchaseSuccess from "./PurchaseSuccess";
import { ShowLoader } from "../../../common/ShowLoader";
import PaymentScreen from "./BeltScreens/PaymentScreen";
import { MobileDeviceNavigationHeader } from "./Common/MobileDeviceNavigationHeader";
import { AppScreens } from "../../Utility/AppScreens";
import PaymentOptions from "../../../Components/profile-common-components/PaymentOptions";
import CheckoutScreen from "../../../Components/profile-common-components/CheckoutScreen";
import Header from "./Common/Header";
import { ScreenBGGradientView } from "../../../common/CommonView";

const RedeemEventScreen = () => {
  const navigation = useNavigation();
  const styles = useStyles();
  const deviceSize = useDeviceSize();

  const [userData, setUserData] = useState(null);

  useEffect(() => {
    getLoginUserData();
  }, []);
  async function getLoginUserData() {
    const data = await getLoginData();

    if (data != null) {
      setUserData(data);
    }
  }
  return (
    <View style={{ flex: 1 }}>
      <ScreenBGGradientView />
      {/* {deviceSize === DEVICE_SIZES.XS ? (
        <MobileDeviceNavigationHeader
          btnNotificationTapped={() => {
            navigateToScreen(navigation, AppScreens.NotificationScreen);
          }}
          btnSettingTapped={() => {
            navigateToScreen(navigation, AppScreens.SettingWebScreen);
          }}
          btnSearchTapped={() => {
            navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
          }}
        />
      ) : null} */}
      <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {}}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() => {}}
      />
      <ScrollView contentContainerStyle={{ flexGrow: 1 }}>
        <View style={styles.container}>
          <View
            style={{
              height: "7%",
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_32,
                { color: AppColors.white, alignSelf: "center" },
              ]}
            >
              Payment
            </Text>
            <TouchableOpacity
              onPress={() => {
                navigateToScreen(navigation, AppScreens.UserProfile);
              }}
              style={{
                justifyContent: "center",
                flexDirection: "row",
                alignItems: "center",
                gap: 10,
              }}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_14,
                  { color: AppColors.white, alignSelf: "center" },
                ]}
              >
                {userData != null ? userData.username : ""}
              </Text>
              <View
                style={{
                  height: "80%",
                  aspectRatio: 1,
                  backgroundColor: AppColors.appViolentColor_6D08C3,
                  borderRadius: 100,
                }}
              />
            </TouchableOpacity>
          </View>
          <View
            style={{
              flexDirection:
                deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM ||
                deviceSize === DEVICE_SIZES.MD ||
                deviceSize === DEVICE_SIZES.LG
                  ? "column"
                  : "row",
              gap: 20,
              // justifyContent: "space-between",
              paddingTop: 30,
            }}
          >
            <View
              style={{
                width:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.MD ||
                  deviceSize === DEVICE_SIZES.LG
                    ? "100%"
                    : "45%",
              }}
            >
              <PaymentOptions />
            </View>
            <View
              style={{
                width:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.MD ||
                  deviceSize === DEVICE_SIZES.LG
                    ? "100%"
                    : "55%",
              }}
            >
              <CheckoutScreen />
            </View>
          </View>
        </View>
      </ScrollView>
    </View>
  );
};

export default RedeemEventScreen;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: "transparent",
      paddingHorizontal: "3.5%",
      paddingTop: "2.5%",
    },
    needHelpButtonStyle: {
      justifyContent: "flex-end",
      alignItems: "center",
      flexDirection: "row",
      paddingHorizontal: 20,
      marginVertical: 5,
      gap: 8,
    },
    packegeSelectionView: {
      borderRadius: 10,
      borderWidth: 1,
      borderColor: AppColors.appViolentColor_6D08C3,
      flexDirection: "row",
      overflow: "hidden",
    },
    separaterStyle: {
      height: 2,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      marginVertical: 10,
    },
    tokenButtonStyle: {
      justifyContent: "center",
      alignItems: "center",
      padding: 10,
      paddingHorizontal: 29,
    },
    packageBgView: {
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      justifyContent: "space-between",
      borderRadius: 10,
      marginVertical: 5,
      marginHorizontal: 5,
      paddingHorizontal: 15,
      paddingVertical: 12,
      gap: 18,
    },
    purchaseNowButtonStyle: {
      height: 40,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      borderRadius: 10,
      justifyContent: "center",
      paddingHorizontal: 30,
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      needHelpButtonStyle: {
        justifyContent: "flex-end",
        alignItems: "center",
        flexDirection: "row",
        paddingHorizontal: 20,
        marginVertical: 5,
        gap: 8,
      },
      packegeSelectionView: {
        borderRadius: 10,
        borderWidth: 1,
        borderColor: AppColors.appViolentColor_6D08C3,
        flexDirection: "row",
        overflow: "hidden",
      },
      separaterStyle: {
        height: 2,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        marginVertical: 10,
      },
      tokenButtonStyle: {
        justifyContent: "center",
        alignItems: "center",
        padding: 10,
        paddingHorizontal: 29,
      },
      packageBgView: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        justifyContent: "space-between",
        borderRadius: 10,
        marginVertical: 5,
        marginHorizontal: 5,
        paddingHorizontal: 15,
        paddingVertical: 12,
        gap: 18,
      },
      purchaseNowButtonStyle: {
        height: 40,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 10,
        justifyContent: "center",
        paddingHorizontal: 30,
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      needHelpButtonStyle: {
        justifyContent: "flex-end",
        alignItems: "center",
        flexDirection: "row",
        paddingHorizontal: 20,
        marginVertical: 5,
        gap: 8,
      },
      packegeSelectionView: {
        borderRadius: 10,
        borderWidth: 1,
        borderColor: AppColors.appViolentColor_6D08C3,
        flexDirection: "row",
        overflow: "hidden",
      },
      separaterStyle: {
        height: 2,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        marginVertical: 10,
      },
      tokenButtonStyle: {
        justifyContent: "center",
        alignItems: "center",
        padding: 10,
        paddingHorizontal: 29,
      },
      packageBgView: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        justifyContent: "space-between",
        borderRadius: 10,
        marginVertical: 5,
        marginHorizontal: 5,
        paddingHorizontal: 15,
        paddingVertical: 12,
        gap: 18,
      },
      purchaseNowButtonStyle: {
        height: 40,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 10,
        justifyContent: "center",
        paddingHorizontal: 30,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      needHelpButtonStyle: {
        justifyContent: "flex-end",
        alignItems: "center",
        flexDirection: "row",
        paddingHorizontal: 20,
        marginVertical: 5,
        gap: 8,
      },
      packegeSelectionView: {
        borderRadius: 10,
        borderWidth: 1,
        borderColor: AppColors.appViolentColor_6D08C3,
        flexDirection: "row",
        overflow: "hidden",
      },
      separaterStyle: {
        height: 2,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        marginVertical: 10,
      },
      tokenButtonStyle: {
        justifyContent: "center",
        alignItems: "center",
        padding: 10,
        paddingHorizontal: 29,
      },
      packageBgView: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        justifyContent: "space-between",
        borderRadius: 10,
        marginVertical: 5,
        marginHorizontal: 5,
        paddingHorizontal: 15,
        paddingVertical: 12,
        gap: 18,
      },
      purchaseNowButtonStyle: {
        height: 40,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 10,
        justifyContent: "center",
        paddingHorizontal: 30,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      needHelpButtonStyle: {
        justifyContent: "flex-end",
        alignItems: "center",
        flexDirection: "row",
        paddingHorizontal: 20,
        marginVertical: 5,
        gap: 8,
      },
      packegeSelectionView: {
        borderRadius: 10,
        borderWidth: 1,
        borderColor: AppColors.appViolentColor_6D08C3,
        flexDirection: "row",
        overflow: "hidden",
      },
      separaterStyle: {
        height: 2,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        marginVertical: 10,
      },
      tokenButtonStyle: {
        justifyContent: "center",
        alignItems: "center",
        padding: 10,
        paddingHorizontal: 29,
      },
      packageBgView: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        justifyContent: "space-between",
        borderRadius: 10,
        marginVertical: 5,
        marginHorizontal: 5,
        paddingHorizontal: 15,
        paddingVertical: 12,
        gap: 18,
      },
      purchaseNowButtonStyle: {
        height: 40,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 10,
        justifyContent: "center",
        paddingHorizontal: 30,
      },
    },
  }
);
